import structureTypes from 'common/constants/structureTypes'
import { OldEntityInterface } from 'common/types/entities/OldEntityInterface'
import ServerPage from 'server/types/ServerPageInterface'
import { migratePhysicalProduct } from './migratePhysicalProduct'

export default function (page: ServerPage): [ServerPage, boolean] {
  let isChanged = false
  Object.values(page.content.entities).forEach(entity => {
    if (entity.type === structureTypes.PHYSICAL_PRODUCT) {
      isChanged = true
      page.content.entities[entity.id] = migratePhysicalProduct(
        entity as OldEntityInterface,
      )
    }
  })

  return [page, isChanged]
}
